import React from "react";
import { Col } from "react-bootstrap";
import styles from "./FullHeightCard.module.css";
import pageContainerStyles from "../pageContainer/PageContainer.module.css";

function FullHeightCard({
  children,
  xs = true,
  header,
  pageContainerChild,
  notColAsContainer,
  handleScroll,
  ...props
}) {
  const Container = React.useMemo(() => {
    return notColAsContainer
      ? ({ children, className }) => <div className={className}>{children}</div>
      : Col;
  }, [notColAsContainer]);

  const scrolling = (e) => {
    const final = (e.target.scrollHeight - parseInt(e.target.scrollTop))
    const bottom =  final < e.target.clientHeight + 10
    if (handleScroll && bottom) handleScroll();
  };

  return (
    <Container
      {...props}
      xs={xs}
      className={`${styles.container} ${
        pageContainerChild ? pageContainerStyles.pageContainerChild : ""
      } ${props.className}`}
    >
      <div className={styles.contentContainer} onScroll={scrolling}>
        {header ? (
          <>
            {header} <hr className="m-1" />
          </>
        ) : null}
        <div className={styles.body}>{children}</div>
      </div>
    </Container>
  );
}
export default FullHeightCard;
